import script from "./form-menu.vue?vue&type=script&setup=true&lang=js"
export * from "./form-menu.vue?vue&type=script&setup=true&lang=js"
/* custom blocks */
import block0 from "./menu.scss?vue&type=custom&index=0&blockType=link&issuerPath=D%3A%5Cvsts-agent%5C_work%5C42%5Cs%5Csrc%5Cviews%5Cmenu%5Cform-menu.vue"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__